import React, { useState, useEffect } from "react";
import AddActivitiesPage1 from "./AddActivitiesPages/AddActivitiesPage1";
import AddActivitiesPage2 from "./AddActivitiesPages/AddActivitiesPage2";
import { GAME_API } from "../../../../constants/api";
import { ADMIN_GAMES } from "../../../../constants/api";
import { R_ACTIVITIES } from "../../../../constants/routes";
import axios from "axios";
import { getCurrentUser, fetchAuthSession } from "@aws-amplify/auth";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const AddActivities = (props) => {
  const [currentPage, setCurrentPage] = useState(null);
  const [currentPageState, setCurrentPageState] = useState("page1");
  const [pageControl, setPageControl] = useState(true);
  const [errorField, setErrorField] = useState({});
  const [games, setGames] = useState(null);
  const [gamesMapField, setGamesMapField] = useState(null);
  const history = useHistory();
  const [pathValid, setPathValid] = useState(null);
  const [gameImage, setGameImage] = useState(null);
  const [pdfAudio, setPdfAudio] = useState(null);
  const [propsData, setPropsData] = useState(props || null);

  const [gameData, setGameData] = useState(propsData.game || null);

  useEffect(() => {
    if (propsData?.game?.length > 0 && propsData?.game !== null) {
      setGameData(propsData.game);
    } else if (games) {
      const url = window.location.href; 
      const parts = url.split("/"); 
      const id = parts[parts.length - 1];
      const gameDataFound = games?.filter((g) => g.id === id)[0]
      setPropsData({ ...propsData, game: gameDataFound });
      setGameData(gameDataFound);
    }
  }, [propsData.game, games]);

  // Valida os campos da página atual
  const updateValidateField = async () => {
    const hasError = await validatePage(currentPageState);
    setPageControl(true);
  };

  // Atualiza os dados quando o jogo e os jogos são carregados
  useEffect(() => {
    if (propsData.game && games) {
      updateValidateField();
    }
  }, [gameData, games]);

  // Carrega dados dos jogos do localStorage ou define o ID do novo jogo
  useEffect(() => {
    if (!games) {
      const gamesLocal = localStorage.getItem("games");
      if (gamesLocal && gamesLocal.length > 1) {
        setGames(JSON.parse(gamesLocal));
      }
    } else {
      if (!propsData.game) {
        // Gera novo ID para jogo
        setGameData((prevState) => ({
          ...prevState,
          id: games.reduce((finallyId, game) => {
            return game.id >= finallyId ? parseInt(game.id) + 1 : finallyId;
          }, 1),
        }));
      } else {
        // Garante que o array "infos" tenha no mínimo 3 elementos
        if (propsData?.game?.infos?.length < 3) {
          setGameData((prevState) => ({
            ...prevState,
            infos: [JSON.parse(JSON.stringify(propsData.game?.infos))],
          }));
        }
      }
      // Cria um "mapa" com informações úteis dos jogos
      setPageControl(true);
      if (games.length > 0) {
        const gameMap = Object.keys(games[0]).reduce((mapGame, atribute) => {
          mapGame[atribute] = games.reduce((ability, game) => {
            if (
              Array.isArray(game[atribute]) &&
              ["infos", "credits"].indexOf(atribute) === 0
            ) {
              return [...ability, ...game[atribute]];
            } else if (
              typeof game[atribute] === "string" &&
              atribute !== "id"
            ) {
              return [...ability, game[atribute]];
            } else if (atribute === "id") {
              return [...ability, { name: game["name"], id: game["id"] }];
            } else if (atribute === "credits") {
              if (Array.isArray(ability)) {
                ability = {};
              }
              ability["elaboration"] = [
                ...(ability["elaboration"] ? ability["elaboration"] : []),
                ...game[atribute]["elaboration"],
              ];
              ability["development"] = [
                ...(ability["development"] ? ability["development"] : []),
                ...game[atribute]["development"],
              ];
              ability["illustration"] = [
                ...(ability["illustration"] ? ability["illustration"] : []),
                ...game[atribute]["illustration"],
              ];
            }
            return ability;
          }, []);
          // Remove duplicados
          if (Array.isArray(mapGame[atribute])) {
            mapGame[atribute] = mapGame[atribute].filter(
              (ability, index, self) =>
                ability && self.indexOf(ability) === index
            );
          } else {
            mapGame[atribute] = Object.keys(mapGame[atribute]).reduce(
              (finallyMap, item) => {
                finallyMap[item] = mapGame[atribute][item].filter(
                  (ability, index, self) => self.indexOf(ability) === index
                );
                return finallyMap;
              },
              {}
            );
          }
          return mapGame;
        }, {});
        setGamesMapField(gameMap);
      }
    }
  }, [games]);

  // Campos obrigatórios para cada página
  const requiredFields = {
    page1: [
      "id",
      "name",
      "engine",
      "type",
      "difficulty",
      "language",
      "qtd_levels",
      "release_date",
      "version",
      "visible",
      "path",
      "main_ability_tag",
      "time",
    ],
    page2: ["credits"],
  };

  // Função para validar uma página específica
  const validatePage = async (page) => {
    let hasError = false;
    const newErrorField = await requiredFields[page].reduce(
      async (finallyObjPromesse, gameKey) => {
        const finallyObj = await finallyObjPromesse;
        finallyObj[gameKey] = await validateField(gameKey, gameData[gameKey]);
        hasError =
          hasError || (finallyObj[gameKey] && finallyObj[gameKey].length > 0);
        return finallyObj;
      },
      {}
    );
    setErrorField({ ...errorField, ...newErrorField });
    return hasError;
  };

  // Avança para próxima página se não houver erro
  const nextPage = async () => {
    const hasError = await validatePage("page1");

    if (!hasError) {
      setCurrentPageState("page2");
    }
    setPageControl(true);
  };

  // Volta para a página anterior
  const backPage = () => {
    setCurrentPageState("page1");
    setPageControl(true);
  };

  // Finaliza o cadastro do jogo
  const finalizeRegister = async () => {
    const hasError = await validatePage("page1");
    if (hasError) {
      setPageControl(true);
      return false;
    }
    saveGame();
  };

  // Define o fluxo de renderização das páginas
  const registerFlow = {
    page1: () => {
      return (
        <AddActivitiesPage1
          nextPage={nextPage}
          gameData={gameData}
          updatedGameDate={updatedGameDate}
          errorField={errorField}
          gamesMapField={gamesMapField}
          pathValid={pathValid}
          gameImage={gameImage}
          pdfAudio={pdfAudio}
        />
      );
    },
    page2: () => {
      return (
        <AddActivitiesPage2
          backPage={backPage}
          finalizeRegister={finalizeRegister}
          gameData={gameData}
          updatedGameDate={updatedGameDate}
          errorField={errorField}
          gamesMapField={gamesMapField}
        />
      );
    },
  };

  // Atualiza os dados do jogo
  const updatedGameDate = async (keyProp, valueChange) => {
    console.log("value", valueChange);
    const currentGameData = gameData;

    if (Array.isArray(keyProp)) {
      // Atualiza campos aninhados (ex: infos[0].title)
      keyProp.reduce((acc, key, index) => {
        if (index === keyProp.length - 1) {
          acc[key] = valueChange;
        } else {
          if (typeof keyProp[index + 1] === "number") {
            acc[key] = acc[key] || [];
          } else {
            acc[key] = acc[key] || {};
          }
        }
        return acc[key];
      }, currentGameData);
    } else {
      currentGameData[keyProp] = valueChange;
      const errorFieldCurrent = await validateField(
        keyProp,
        currentGameData[keyProp]
      );
      setErrorField((prevState) => ({
        ...prevState,
        [keyProp]: errorFieldCurrent,
      }));
    }
    setPageControl(true);
    console.log("currentGameData", currentGameData);
    setGameData(currentGameData);
  };

  // Verifica se uma imagem do jogo pode ser carregada
  const loadImage = async (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve("ok");
      };
      img.onerror = () => {
        reject(new Error("Erro ao carregar imagem."));
      };
      img.src = url;
    });
  };

  // Validações específicas para cada campo
  const mapValidateField = {
    id: (value) => {
      if (isNaN(value)) {
        return "Id não é válido";
      }
      return null;
    },
    name: (value) => {
      if (!value) return "Campo está vazio";
      if (
        games.filter(
          (g) =>
            g.name === value &&
            (!propsData || !propsData.game || propsData.game.name !== value)
        ).length > 0
      ) {
        return "Nome já existe";
      }
      return null;
    },
    pathGame: async (value) => {
      try {
        const response = await fetch(GAME_API + "/" + value + "/index.html");
        console.log("path", response);
        if (!response.ok) {
          setPathValid(false);
          return "Caminho inválido. Suba primeiro o jogo no GitHub.";
        }
        setPathValid(true);
      } catch (error) {
        console.log(error);
        setPathValid(false);
        return "Caminho inválido. Suba primeiro o jogo no GitHub.";
      }

      // Verifica imagem do jogo
      try {
        const urlImage = GAME_API + "/" + value + "/jogo_imagem_.jpg";
        const response = await loadImage(urlImage);
        if (response !== "ok") {
          setGameImage(false);
          return "O caminho não possui uma imagem válida.";
        }
        setGameImage(urlImage);
      } catch (error) {
        console.log("deu ruim", error);
        setGameImage(false);
        return "o caminho não possui uma imagem válida.";
      }
      return null;
    },
    pathAudio: async (value) => {
      try {
        const response = await fetch(GAME_API + "/" + value + "/audio.mp3");
        console.log("path", response);
        if (!response.ok) {
          setPathValid(false);
          return "Caminho inválido. Suba primeiro o jogo no GitHub.";
        }
        setPathValid(true);
      } catch (error) {
        console.log(error);
        setPathValid(false);
        return "Caminho inválido. Suba primeiro o jogo no GitHub.";
      }

      // Verifica imagem relacionada ao áudio
      try {
        const urlImage = GAME_API + "/" + value + "/audio_imagem_.jpg";
        const response = await loadImage(urlImage);
        if (response !== "ok") {
          setGameImage(false);
          return "O caminho não possui uma imagem válida.";
        }
        setGameImage(urlImage);
      } catch (error) {
        console.log("deu ruim", error);
        setGameImage(false);
        return "o caminho não possui uma imagem válida.";
      }

      // Verifica PDF relacionado ao jogo de áudio
      try {
        const urlPdf = GAME_API + "/" + value + "/gabarito.pdf";
        const response = await fetch(urlPdf);
        if (!response.ok) {
          setPdfAudio(false);
          return "O caminho não possui um gabarito válido.";
        }
        setPdfAudio(urlPdf);
      } catch (error) {
        console.log("deu ruim", error);
        setPdfAudio(false);
        return "O caminho não possui um gabarito válido.";
      }

      return null;
    },
    path: async (value) => {
      if (!value?.toString().length > 0) {
        setPathValid(false);
        return "Este campo não pode permanecer vazio";
      }
      const typeMap = {
        jogo: "pathGame",
        audio: "pathAudio",
      };

      const gameType = typeMap[gameData["type"]];
      if (gameType in mapValidateField) {
        return mapValidateField[gameType](value);
      } else {
        return "O caminho do tipo da atividade não pode ser testado";
      }
      return null;
    },
    default: async (value) => {
      console.log("value", value);
      if (value === undefined) return "Este campo não pode permanecer vazio";
      return (
        !(value?.toString().length > 0) &&
        "Este campo não pode permanecer vazio"
      );
    },
  };

  // Valida um campo com base na chave do jogo
  const validateField = async (gameKey, gameField) => {
    if (mapValidateField.hasOwnProperty(gameKey)) {
      return await mapValidateField[gameKey](gameField);
    }
    return await mapValidateField["default"](gameField);
  };

  // Salva os dados do jogo
  const saveGame = () => {
    if (propsData.saveGame) {
      propsData.saveGame(gameData);
      return false;
    }
    // Autentica e envia os dados via API
    getCurrentUser()
      .then(async (user) => {
        const session = await fetchAuthSession({
          forceRefresh: true,
        });
        const userToken = session.tokens?.idToken?.toString();
        return axios.post(
          ADMIN_GAMES,
          { game: gameData },
          {
            headers: {
              Authorization: userToken,
              "Content-Type": "application/json",
            },
          }
        );
      })
      .then((response) => {
        console.log(response.status);
        if (response.status === 200) {
          console.log("status 200");
          history.push(R_ACTIVITIES);
        }
      })
      .catch((error) => {
        console.error("Error saving game:", error);
        setErrorField({ ...errorField, ...error });
      });
  };

  // Controla a navegação entre páginas do fluxo de registro
  useEffect(() => {
    if (
      pageControl &&
      currentPageState in registerFlow &&
      gameData &&
      gameData.id
    ) {
      setCurrentPage(registerFlow[currentPageState]);
      setPageControl(false);
    }
  }, [currentPageState, currentPage, pageControl, errorField, gameData]);

  return <div>{currentPage}</div>;
};

export default AddActivities;
